import type { ListPageConfig } from '../types'

export const workerFilterConfig: ListPageConfig = {
  routeId: '/workforce/',
  pageId: 'workers',
  pagination: { pageSize: 20 },
  fields: [
    {
      id: 'search',
      label: 'Search',
      type: 'search',
      placeholder: 'Search workers...',
      serverSide: true,
    },
    {
      id: 'type',
      label: 'Type',
      type: 'select',
      allLabel: 'All Types',
      serverSide: true,
      options: [
        { value: 'EMPLOYEE', label: 'Employee' },
        { value: 'CONTRACTOR', label: 'Contractor' },
      ],
    },
  ],
}
